import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { useConsultation } from './ConsultationContext';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const {
    openModal
  } = useConsultation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-cream/95 backdrop-blur-md shadow-sm py-2' : 'bg-transparent py-4'}`} data-id="element-155">
      <div className="container mx-auto px-4 md:px-6 h-[60px] flex items-center justify-between" data-id="element-156">
        <a href="#" className="flex items-center z-50 shrink-0" data-id="element-157">
          <img src="https://cdn.magicpatterns.com/uploads/4HjToFW6Qh7G34cF6bz1jy/Be_Clinical_logo_navy_hex.png" alt="Be Clinical" className="h-12 w-12 object-contain" data-id="element-158" />
        </a>

        <button onClick={openModal} className="shrink-0 inline-flex items-center justify-center bg-gold text-white hover:bg-gold-hover font-sans font-bold uppercase tracking-wider text-xs px-6 py-2.5 rounded-sm shadow-sm hover:shadow-md transition-all duration-300" data-id="element-159">
          Book Now
        </button>
      </div>
    </header>;
}